import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';


interface GiftDetailProps {
  selectedFormat?: 'frame' | 'wallet' | '';
}

const GiftDetail: React.FC<GiftDetailProps> = ({ selectedFormat }) => {
  return (
    <Card sx={{
      border: '1px solid rgb(209, 196, 233)',
      background: 'linear-gradient(to bottom right, rgba(255, 236, 179, 0.2), rgba(255, 205, 210, 0.2))',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      borderRadius: '12px',
    }}>
      <Box sx={{ p: 2, position: 'relative' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Typography 
              sx={{ 
                color: 'rgb(123, 31, 162)', 
                fontWeight: 'bold', 
                fontSize: '1.125rem', 
                mb: 1, 
              }}
            >
              Introductory Price: $49.95 LGCY Card
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                color: 'rgb(123, 31, 162)', 
                fontSize: '1.25rem', 
                mb: 1, 
              }}
            >
              LGCY Package includes:
            </Typography>
          </Box>

        </Box>
      </Box>
      <CardContent sx={{ pt: 0, pb: 2, px: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
            <Box 
              sx={{ 
                width: 8, 
                height: 8, 
                bgcolor: 'rgb(156, 39, 176)', 
                borderRadius: '50%', 
                mt: 1, 
              }}
            />
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              2 digital LGCY Cards
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
            <Box 
              sx={{ 
                width: 8, 
                height: 8, 
                bgcolor: 'rgb(156, 39, 176)', 
                borderRadius: '50%', 
                mt: 1, 
              }}
            />
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              1 digital Memorial card
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
            <Box 
              sx={{ 
                width: 8, 
                height: 8, 
                bgcolor: 'rgb(156, 39, 176)', 
                borderRadius: '50%', 
                mt: 1, 
              }}
            />
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Personalized and shareable timeline link for family and friends
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
            <Box 
              sx={{ 
                width: 8, 
                height: 8, 
                bgcolor: 'rgb(156, 39, 176)', 
                borderRadius: '50%', 
                mt: 1, 
              }}
            />
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Use "Fluffy", our AI assistant to help tell their stories
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default GiftDetail;